'use strict';

var fireEvent = require('./utils/fireEvent.js');

// Example Payload
// {
//     "type": "track",
//     "event": "landing_page:page_view",
//     "properties": {
//         "currentUser": null,
//         "landing_page_id": "24660c91-5a55-4a2d-aa2d-c7b89737bdf1",
//         "publisherId": "c9298a6f-566d-4507-9def-116384264538"
//     },
//     "options": {},
//     "userId": "userID",
//     "anonymousId": "8fe448a6-1e7a-434b-8374-2bb70c960e4f",
//     "meta": {
//         "rid": "54092386-e367-4c08-b689-f6b48b09647c",
//         "ts": 1634856456432,
//         "hasCallback": true
//     }
// }

var track = function track(_ref) {
  var config = _ref.config,
    instance = _ref.instance,
    payload = _ref.payload;
  // console.log('track patload', payload)
  return fireEvent({
    name: payload.event,
    config: config,
    instance: instance,
    payload: payload.properties
  });
};
var track$1 = track;

module.exports = track$1;
//# sourceMappingURL=track.js.map
